<template>
  <div>
    <recharge :linkSource="linkSource"></recharge>
  </div>
</template>

<script>
import Recharge from '@/components/Recharge/index.vue';
export default {
  components: {
    Recharge
  },
  data: function() {
    return {
      linkSource: ''
    };
  },
  created() {
    if (this.$route.name === 'Saving_hk') {
      this.linkSource = 'hk';
    } else if (this.$route.name === 'Saving_tw') {
      this.linkSource = 'tw';
    }
  }
};
</script>

<style lang="scss" scoped></style>
